import { render, staticRenderFns } from "./StellaButton.vue?vue&type=template&id=15dd6324&scoped=true&"
import script from "./StellaButton.vue?vue&type=script&lang=js&"
export * from "./StellaButton.vue?vue&type=script&lang=js&"
import style0 from "./StellaButton.vue?vue&type=style&index=0&id=15dd6324&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dd6324",
  null
  
)

export default component.exports